const AdGroupShow = () => import('@/modules/campaigns/views/search/AdGroupShow')
const CampaignEdit = () => import('@/modules/campaigns/views/CampaignEdit')
const CampaignImport = () => import('@/modules/campaigns/views/CampaignImport')
const CampaignIndex = () => import('@/modules/campaigns/views/CampaignIndex')
const CampaignRequest = () => import('@/modules/campaigns/views/CampaignRequest')
const CampaignShow = () => import('@/modules/campaigns/views/CampaignShow')
const CampaignLineEdit = () => import('@/modules/campaigns/views/programmatic/CampaignLineEdit')
const CampaignLineShow = () => import('@/modules/campaigns/views/programmatic/CampaignLineShow')
const CampaignPackageEdit = () => import('@/modules/campaigns/views/programmatic/CampaignPackageEdit')
// const CampaignPackageShow = () => import('@/v2/modules/campaigns/views/programmatic/CampaignPackageShow')
// const MetaAdSetShow = () => import('@/v2/modules/campaigns/views/meta/MetaAdSetShow')

export default [
  {
    path: '/campaigns/programmatic/create',
    name: 'campaigns.programmatic.create',
    component: CampaignEdit,
    meta: { requiresAuthentication: true }
  },
  // {
  //   path: '/campaigns/native-contextual/create',
  //   name: 'campaigns.native-contextual.create',
  //   component: CampaignEdit,
  //   meta: { requiresAuthentication: true }
  // },
  // {
  //   path: '/campaigns/native-open/create',
  //   name: 'campaigns.native-open.create',
  //   component: CampaignEdit,
  //   meta: { requiresAuthentication: true }
  // },
  {
    path: '/campaigns/native/create',
    name: 'campaigns.native.create',
    component: CampaignEdit,
    meta: { requiresAuthentication: true }
  },
  // {
  //   path: '/campaigns/search/create',
  //   name: 'campaigns.search.create',
  //   component: CampaignEdit,
  //   meta: { requiresAuthentication: true }
  // },

  // {
  //   path: '/campaigns/meta/create',
  //   name: 'campaigns.meta.create',
  //   component: CampaignEdit,
  //   meta: { requiresAuthentication: true }
  // },
  // {
  //   path: '/campaigns/spotify/create',
  //   name: 'campaigns.spotify.create',
  //   component: CampaignEdit,
  //   meta: { requiresAuthentication: true }
  // },
  {
    path: '/campaigns/youtube/create',
    name: 'campaigns.youtube.create',
    component: CampaignEdit,
    meta: { requiresAuthentication: true }
  },
  // {
  //   path: '/campaigns/push/create',
  //   name: 'campaigns.push.create',
  //   component: CampaignEdit,
  //   meta: { requiresAuthentication: true }
  // },
  {
    path: '/campaigns/meta-ads/create',
    name: 'campaigns.meta-ads.create',
    component: CampaignImport,
    meta: { requiresAuthentication: true }
  },
  // {
  //   path: '/campaigns/tiktok-ads/create',
  //   name: 'campaigns.tiktok-ads.create',
  //   component: CampaignImport,
  //   meta: { requiresAuthentication: true }
  // },
  {
    path: '/campaigns/google-ads/create',
    name: 'campaigns.google-ads.create',
    component: CampaignImport,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/create',
    name: 'campaigns.create',
    component: CampaignEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/import',
    name: 'campaigns.import',
    component: CampaignImport,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns',
    name: 'campaigns.index',
    component: CampaignIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/request',
    name: 'campaigns.request',
    component: CampaignRequest,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:id',
    name: 'campaigns.show',
    component: CampaignShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:id/edit',
    name: 'campaigns.edit',
    component: CampaignEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:cId/ad-groups/:id',
    name: 'ad_groups.show',
    component: AdGroupShow,
    meta: { requiresAuthentication: true }
  },
  // {
  //   path: '/campaigns/:cId/ad-set/:id',
  //   name: 'ad_sets.show',
  //   component: MetaAdSetShow,
  //   meta: { requiresAuthentication: true }
  // },
  {
    path: '/campaigns/:cId/packages/create',
    name: 'packages.create',
    component: CampaignPackageEdit,
    meta: { requiresAuthentication: true }
  },
  // {
  //   path: '/campaigns/:cId/packages/:id',
  //   name: 'packages.show',
  //   component: CampaignPackageShow,
  //   meta: { requiresAuthentication: true }
  // },
  {
    path: '/campaigns/:cId/packages/:id/edit',
    name: 'packages.edit',
    component: CampaignPackageEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:cId/packages/:pId/lines/create',
    name: 'lines.create',
    component: CampaignLineEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:cId/lines/:id',
    name: 'lines.show',
    component: CampaignLineShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:cId/lines/:id/edit',
    name: 'lines.edit',
    component: CampaignLineEdit,
    meta: { requiresAuthentication: true }
  }
]
